var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children, forwardRef, useLayoutEffect, useMemo, useRef, useState, } from 'react';
import { useCombinedRefs } from '../../util/use-combined-refs/use-combined-refs';
import GridContainer from './GridContainer';
import { gapSizes } from './types';
import { calcColumns, useScrollToKeyboardFocus } from './utils';
export var DynamicGrid = forwardRef(function (_a, fRef) {
    var minWidth = _a.minWidth, autoFit = _a.autoFit, _b = _a.maxColumns, maxColumns = _b === void 0 ? Infinity : _b, maxRows = _a.maxRows, _c = _a.modulo, modulo = _c === void 0 ? 1 : _c, _d = _a.gapSize, gapSize = _d === void 0 ? 1 : _d, _e = _a.elementRole, elementRole = _e === void 0 ? 'none' : _e, scroll = _a.scroll, children = _a.children, rest = __rest(_a, ["minWidth", "autoFit", "maxColumns", "maxRows", "modulo", "gapSize", "elementRole", "scroll", "children"]);
    var innerRef = useRef();
    var combinedRef = useCombinedRefs(fRef, innerRef);
    var _f = useState(0), elementWidth = _f[0], setElementWidth = _f[1];
    useLayoutEffect(function () {
        setElementWidth(innerRef.current.clientWidth);
        if (!window.ResizeObserver)
            return;
        var observer = new ResizeObserver(function (entries) {
            return window.requestAnimationFrame(function () {
                return setElementWidth(entries[0].contentRect.width);
            });
        });
        observer.observe(innerRef.current);
        return function () { return observer.disconnect(); };
    }, []);
    var columns = useMemo(function () {
        return calcColumns({
            minWidth: minWidth,
            elementWidth: elementWidth,
            gap: gapSizes[gapSize],
            modulo: modulo,
            maxColumns: maxColumns,
            scrollHint: scroll === null || scroll === void 0 ? void 0 : scroll.scrollHint
        });
    }, [minWidth, elementWidth, gapSize, modulo, maxColumns, scroll === null || scroll === void 0 ? void 0 : scroll.scrollHint]);
    useScrollToKeyboardFocus(innerRef, scroll);
    var childrenAsList = useMemo(function () { return Children.map(children, function (child) { return React.createElement("li", null, child); }); }, [children]);
    return (React.createElement(GridContainer, __assign({ "$minWidth": minWidth, "$autoFit": autoFit, "$maxRows": maxRows, "$columns": columns, "$gap": gapSizes[gapSize], "$scroll": scroll, role: elementRole, ref: combinedRef }, rest), elementRole === 'list' ? childrenAsList : children));
});
